module.exports = __webpack_public_path__ + "img/NLC-D-front.3a049c85.jpg";